import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { DppEnrollmentState } from '../state/dpp-enrollment.state';

export const selectDppEnrollmentState = createFeatureSelector<DppEnrollmentState>('dppEnrollment');

export const selectNpoSearchRequest = createSelector(
    selectDppEnrollmentState,
    (state) => state.npoSearchRequest
);

export const selectEnrollmentStatus = createSelector(
    selectDppEnrollmentState,
    (state) => state.enrollmentStatus
);

export const selectSelectedNpo = createSelector(
    selectDppEnrollmentState,
    (state) => state.selectedNpo
);

export const selectPartnershipChanged = createSelector(
    selectDppEnrollmentState,
    (state) => state.partnershipChanged
);

export const selectNpoSearchCallStatus = createSelector(
    selectDppEnrollmentState,
    (state) => state.npoSearchCallStatus
);

export const selectNpoSearchResults = createSelector(
    selectDppEnrollmentState,
    (state) => state.npoSearchResults
);

export const selectReturnedFromStripe = createSelector(
    selectDppEnrollmentState,
    (state) => state.returnedFromStripe
);

export const selectPageNumber = createSelector(
    selectDppEnrollmentState,
    (state) => state.npoSearchRequest?.pageNumber
);

export const selectEnrollmentStatusCallStatus = createSelector(
    selectDppEnrollmentState,
    (state) => state.enrollmentStatusCallStatus
);

export const selectHasSecondaries = createSelector(
    selectDppEnrollmentState,
    (state) => state.hasSecondaries
);

export const selectShowErrorsIfClean = createSelector(
    selectDppEnrollmentState,
    (state) => state.showErrorsIfClean
);

@Injectable({
    providedIn: 'root',
})
export class DppEnrollmentSelectors {
    npoSearchRequest$ = this.store.select(selectNpoSearchRequest);
    enrollmentStatus$ = this.store.select(selectEnrollmentStatus);
    enrollmentStatusCallStatus$ = this.store.select(selectEnrollmentStatusCallStatus);
    selectedNpo$ = this.store.select(selectSelectedNpo);
    partnershipChanged$ = this.store.select(selectPartnershipChanged);
    npoSearchCallStatus$ = this.store.select(selectNpoSearchCallStatus);
    npoSearchResults$ = this.store.select(selectNpoSearchResults);
    returnedFromStripe$ = this.store.select(selectReturnedFromStripe);
    pageNumber$ = this.store.select(selectPageNumber);
    hasSecondaries$ = this.store.select(selectHasSecondaries);
    showErrorsIfClean$ = this.store.select(selectShowErrorsIfClean);

    constructor(private readonly store: Store<DppEnrollmentState>) {}
}
